export default "__VITE_ASSET__25780f7d__"